import { MessageManager } from '../managers/MessageManager';

export class MessageManagerObserver {
  constructor() {
    this.observer = new MutationObserver(this._handleMutations.bind(this));
    this.observeDocument();
    this.initExistingElements();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initExistingElements() {
    const elem = document.querySelector('#message_manager');
    // Если у элемента ещё нет менеджера, создаём
    if (!elem.messageManager) {
      new MessageManager(elem);
    }
  }

  _handleMutations(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          // Проверяем, является ли добавленный узел контейнером
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Если сам узел — dinamicElement
            if (node.matches && node.matches('#message_manager')) {
              if (!node.messageManager) {
                new MessageManager(node);
              }
            }

            // Если внуки внутри узла — dinamicElement
            node.querySelectorAll?.('#message_manager').forEach((inner) => {
              if (!inner.messageManager) {
                new MessageManager(inner);
              }
            });
          }
        });
      }
    });
  }
}
